import { Column } from "@tanstack/react-table"
import { Group, Switch } from "@mantine/core"
import { IconGripVertical } from "@tabler/icons-react"
import { CSSProperties } from "react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"

type Props<TData> = {
  column: Column<TData, unknown>
}

export function DraggableTableHeader<TData>({ column }: Props<TData>) {
  const { attributes, isDragging, listeners, setNodeRef, transform } =
    useSortable({
      id: column.id,
    })

  const style: CSSProperties = {
    opacity: isDragging ? 0.8 : 1,
    position: "relative",
    transform: CSS.Translate.toString(transform),
    transition: "width transform 0.2s ease-in-out",
    zIndex: isDragging ? 1 : 0,
  }

  return (
    <Group justify={"space-between"} w={"100%"} style={style} ref={setNodeRef}>
      <div
        {...attributes}
        {...listeners}
        style={{ display: "flex", alignItems: "center", gap: 5, flex: 1 }}
      >
        <IconGripVertical size={16} />
        {typeof column.columnDef.header === "string" && column.columnDef.header}
      </div>
      <Switch
        checked={column.getIsVisible()}
        onChange={() => {
          column.toggleVisibility()
        }}
      />
    </Group>
  )
}
